import React, { useContext, useEffect, useState } from 'react';
import * as R from 'ramda';
import { useTranslation } from 'react-i18next';
import Container from '../common/components/Container/Container';
import Button, { ButtonStyle } from '../common/components/Button/Button';
import ButtonContainer from '../common/components/Button/ButtonContainer';
import TitleContainer from '../common/components/TitleContainer/TitleContainer';
import { FlowConfigContext } from '../providers/FlowConfigContext';
import withRouteAnalytics from '../services/analytics/withRouteAnalytics';
import { GatekeeperNetworkServiceContext } from '../providers/GatekeeperNetworkService/GatekeeperNetworkServiceContext';
import PiiDataTypesToShare from '../common/components/piiSharing/PiiDataTypesToShare';
import { Screens } from '../services/analytics/screens';

function SharePersonalDetailsScreen(): JSX.Element {
  const { navigateToNextFlow, setAgreedToShareData, flowCancelled, agreedToShareData } = useContext(FlowConfigContext);
  const { networkName } = useContext(FlowConfigContext);
  const { gknServiceData } = useContext(GatekeeperNetworkServiceContext);
  const { t } = useTranslation();

  const partnerName: string = R.propOr(false, 'partnerName', gknServiceData);
  const [showCancelConfirmation, setShowCancelConfirmation] = useState<boolean>(false);

  useEffect(() => {
    navigateToNextFlow();
  }, [agreedToShareData]);

  const authorize = () => {
    setAgreedToShareData(true);
  };

  const handleCancel = () => {
    setShowCancelConfirmation(true);
  };

  const handleGoBack = () => {
    setShowCancelConfirmation(false);
  };

  const handleClose = () => {
    flowCancelled();
  };

  return (
    <Container>
      {!showCancelConfirmation ? (
        <>
          <TitleContainer center>
            <h1 style={{ fontWeight: 'normal' }} data-testid="CAPTURE_PERSONAL_DETAILS_SCREEN">
              {t('screens.authorizePersonalInfo.title')}
              <span className="font-bold whitespace-nowrap">{partnerName}</span>
            </h1>
          </TitleContainer>

          <PiiDataTypesToShare />

          <ButtonContainer bottomMargin="mb-2 mt-4">
            <Button
              style={ButtonStyle.DEFAULT}
              disabled={false}
              loading={false}
              dataTestid="CONFIRM_SHARE_BUTTON"
              onClick={authorize}
            >
              <span>{t('screens.authorizePersonalInfo.continueButton', { context: networkName })}</span>
            </Button>

            <Button
              style={ButtonStyle.INVERTED}
              extraClasses="mt-2"
              disabled={false}
              onClick={handleCancel}
              dataTestid="CANCEL_BUTTON"
            >
              <span>{t('screens.captchaPass.terms.cancelLabel')}</span>
            </Button>
          </ButtonContainer>
        </>
      ) : (
        <>
          <TitleContainer center>
            <h1 style={{ fontWeight: 'bold' }} data-testid="CAPTURE_PERSONAL_DETAILS_SCREEN">
              {t('screens.authorizePersonalInfo.confirmation.title')}
            </h1>

            <div className="mt-2 text-md">{t('screens.authorizePersonalInfo.confirmation.description')}</div>
          </TitleContainer>
          <ButtonContainer bottomMargin="mb-2 mt-4">
            <Button
              style={ButtonStyle.DEFAULT}
              disabled={false}
              loading={false}
              dataTestid="CONFIRM_SHARE_BUTTON"
              onClick={handleGoBack}
            >
              <span>{t('screens.authorizePersonalInfo.confirmation.goBackButton', { context: networkName })}</span>
            </Button>

            <Button
              style={ButtonStyle.INVERTED}
              extraClasses="mt-2"
              disabled={false}
              onClick={handleClose}
              dataTestid="CANCEL_BUTTON"
            >
              <span>{t('screens.authorizePersonalInfo.confirmation.closeButton')}</span>
            </Button>
          </ButtonContainer>
        </>
      )}
    </Container>
  );
}
export default withRouteAnalytics(SharePersonalDetailsScreen, Screens.APPROVE_PII_CAPTURING);
